import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";

import { isEmpty } from "lodash";
import "../../settings.styles.css";

import DeleteModal from "../../../../Components/Common/DeleteModal";
import SettingsPanel from "../../components/SettingsPanel";

import { toast } from "react-toastify";

import {
  addProductUnitType,
  addProductUnitTypeSuccess,
  deleteProductUnitType,
  deleteProductUnitTypeSuccess,
  getProductUnitTypeList,
  updateProductUnitType,
  updateProductUnitTypeSuccess,
} from "../../../../store/product/action";
import {
  addMasterTimeFrame,
  addMasterTimeFrameSuccess,
  addRenewalFrequencies,
  addRenewalFrequenciesSuccess,
  addUnitFrequencies,
  addUnitFrequenciesSuccess,
  deleteMasterTimeFrame,
  deleteMasterTimeFrameSuccess,
  deleteRenewalFrequencies,
  deleteRenewalFrequenciesSuccess,
  deleteUnitFrequencies,
  deleteUnitFrequenciesSuccess,
  getMasterTimeFrameList,
  getRenewalFrequenciesList,
  getUnitFrequenciesList,
  updateMasterTimeFrame,
  updateMasterTimeFrameSuccess,
  updateRenewalFrequencies,
  updateRenewalFrequenciesSuccess,
  updateUnitFrequencies,
  updateUnitFrequenciesSuccess,
} from "../../../../store/generalSettings/action";
import LocalSettings from "./localSettings";
import UserProfileLocalSettings from "./localSettings";
import FeedbackToolToggle from "../../components/FeedbackToolToggle";
export default function UserProfileGeneralSettings() {
  const dispatch = useDispatch();

  const [statusList, setStatusList] = useState([]);
  const [activeTab] = useState("1");
  const [deleteStatus, setDeleteStatus] = useState("");
  const [config, setConfig] = useState(null);
  const [createStatus, setCreateStatus] = useState({
    Name: "New Status",
    CssColourText: "#000000",
    CssColourBackground: "#F4F0F0",
    IntervalValueMathSign: "+",
    IntervalValue: 7,
    MasterTimeFrameInterval_Id: "1",
  });

  const { productUnitTypeListAPI } = useSelector((state) => ({
    productUnitTypeListAPI:
      state.ProductCrmIT.productUnitTypeList?.unittype_list,
  }));
  const {
    renewalFrequenciesListAPI,
    unitFrequenciesListAPI,
    masterTimeFrameListAPI,
  } = useSelector((state) => ({
    renewalFrequenciesListAPI:
      state.GeneralSettings.renewalFrequenciesList?.renewalfrequency_list,
    unitFrequenciesListAPI:
      state.GeneralSettings.unitFrequenciesList?.unitfrequency_list,
    masterTimeFrameListAPI:
      state.GeneralSettings.masterTimeFrameList?.mastertimeframeinterval_list,
  }));

  const handleCreateNewStatus = () => {
    if (activeTab === "1") {
      //   Status create
      dispatch(addProductUnitType([createStatus]));
    }
    if (activeTab === "4") {
      dispatch(addRenewalFrequencies([createStatus]));
    }
    if (activeTab === "5") {
      dispatch(addUnitFrequencies([createStatus]));
    }
    if (activeTab === "6") {
      dispatch(addMasterTimeFrame([createStatus]));
    }
  };

  useEffect(() => {
    let data = [];
    if (activeTab === "1") {
      data = productUnitTypeListAPI?.sort((a, b) => b.Id - a.Id);
      setConfig(null);
    }
    if (activeTab === "4") {
      data = renewalFrequenciesListAPI?.sort((a, b) => b.Id - a.Id);
      setConfig({
        name: "generalSettingsFrequency",
        data: masterTimeFrameListAPI,
      });
    }
    if (activeTab === "5") {
      data = unitFrequenciesListAPI?.sort((a, b) => b.Id - a.Id);
      setConfig({
        name: "generalSettingsFrequency",
        data: masterTimeFrameListAPI,
      });
    }
    if (activeTab === "6") {
      data = masterTimeFrameListAPI?.sort((a, b) => b.Id - a.Id);
      setConfig({
        name: "generalSettingsMasterFrequency",
      });
    }
    setStatusList(data);
  }, [
    productUnitTypeListAPI,
    activeTab,
    renewalFrequenciesListAPI,
    unitFrequenciesListAPI,
    masterTimeFrameListAPI,
  ]);

  const [deleteModal, setDeleteModal] = useState(false);
  const handleDeleteStatus = () => {
    if (activeTab === "1") {
      //   Status delete
      dispatch(deleteProductUnitType([deleteStatus]));
    }
    if (activeTab === "4") {
      dispatch(deleteRenewalFrequencies([deleteStatus]));
    }
    if (activeTab === "5") {
      dispatch(deleteUnitFrequencies([deleteStatus]));
    }
    if (activeTab === "6") {
      dispatch(deleteMasterTimeFrame([deleteStatus]));
    }
  };
  const [updateItemStatus, setUpdateItemStatus] = useState({});

  // Update Module
  useEffect(() => {
    if (isEmpty(updateItemStatus)) return;
    let updateNewStatus = {
      Id: updateItemStatus?.Id,
      Name: updateItemStatus?.Name,
      CssColourBackground: updateItemStatus?.CssColourBackground,
      CssColourText: updateItemStatus?.CssColourText,
      IntervalValue: updateItemStatus?.IntervalValue,
      IntervalValueMathSign: updateItemStatus?.IntervalValueMathSign,
      MasterTimeFrameInterval_Id: updateItemStatus?.MasterTimeFrameInterval_Id,
    };
    const delayUpdate = setTimeout(() => {
      if (activeTab === "1") {
        //  Status update
        dispatch(updateProductUnitType([updateNewStatus]));
      }
      if (activeTab === "4") {
        dispatch(updateRenewalFrequencies([updateNewStatus]));
      }
      if (activeTab === "5") {
        dispatch(updateUnitFrequencies([updateNewStatus]));
      }
      if (activeTab === "6") {
        dispatch(updateMasterTimeFrame([updateNewStatus]));
      }
    }, 500);
    return () => clearTimeout(delayUpdate);
  }, [updateItemStatus]);

  //Effects
  const {
    addProductUnitTypeSuccessAPI,
    updateProductUnitTypeSuccessAPI,
    deleteProductUnitTypeSuccessAPI,
    addRenewalFrequenciesSuccessAPI,
    updateRenewalFrequenciesSuccessAPI,
    deleteRenewalFrequenciesSuccessAPI,
    addUnitFrequenciesSuccessAPI,
    updateUnitFrequenciesSuccessAPI,
    deleteUnitFrequenciesSuccessAPI,
    addMasterTimeFrameSuccessAPI,
    updateMasterTimeFrameSuccessAPI,
    deleteMasterTimeFrameSuccessAPI,
  } = useSelector((state) => ({
    addProductUnitTypeSuccessAPI: state.ProductCrmIT.addProductUnitTypeSuccess,
    updateProductUnitTypeSuccessAPI:
      state.ProductCrmIT.updateProductUnitTypeSuccess,
    deleteProductUnitTypeSuccessAPI:
      state.ProductCrmIT.deleteProductUnitTypeSuccess,
    addRenewalFrequenciesSuccessAPI:
      state.GeneralSettings.addRenewalFrequenciesSuccess,
    updateRenewalFrequenciesSuccessAPI:
      state.GeneralSettings.updateRenewalFrequenciesSuccess,
    deleteRenewalFrequenciesSuccessAPI:
      state.GeneralSettings.deleteRenewalFrequenciesSuccess,
    addUnitFrequenciesSuccessAPI:
      state.GeneralSettings.addUnitFrequenciesSuccess,
    updateUnitFrequenciesSuccessAPI:
      state.GeneralSettings.updateUnitFrequenciesSuccess,
    deleteUnitFrequenciesSuccessAPI:
      state.GeneralSettings.deleteUnitFrequenciesSuccess,
    addMasterTimeFrameSuccessAPI:
      state.GeneralSettings.addMasterTimeFrameSuccess,
    updateMasterTimeFrameSuccessAPI:
      state.GeneralSettings.updateMasterTimeFrameSuccess,
    deleteMasterTimeFrameSuccessAPI:
      state.GeneralSettings.deleteMasterTimeFrameSuccess,
  }));

  // Effects add unit type success
  useEffect(() => {
    if (isEmpty(addProductUnitTypeSuccessAPI)) return;
    if (addProductUnitTypeSuccessAPI?.status === 200) {
      toast.success(addProductUnitTypeSuccessAPI?.message);
      dispatch(getProductUnitTypeList());
    } else {
      toast.error(addProductUnitTypeSuccessAPI?.message);
    }
    dispatch(addProductUnitTypeSuccess([]));
  }, [addProductUnitTypeSuccessAPI]);

  // Effect update unit type success
  useEffect(() => {
    if (isEmpty(updateProductUnitTypeSuccessAPI)) return;
    if (updateProductUnitTypeSuccessAPI?.status === 200) {
      toast.success(updateProductUnitTypeSuccessAPI?.message);
      dispatch(getProductUnitTypeList());
    } else {
      toast.error(updateProductUnitTypeSuccessAPI?.message);
    }
    dispatch(updateProductUnitTypeSuccess([]));
  }, [updateProductUnitTypeSuccessAPI]);

  // Effect delete unit type success
  useEffect(() => {
    if (isEmpty(deleteProductUnitTypeSuccessAPI)) return;
    if (deleteProductUnitTypeSuccessAPI?.status === 200) {
      toast.success(deleteProductUnitTypeSuccessAPI?.message);
      dispatch(getProductUnitTypeList());
      setDeleteModal(false);
    } else {
      toast.error(deleteProductUnitTypeSuccessAPI?.message);
    }
    dispatch(deleteProductUnitTypeSuccess([]));
  }, [deleteProductUnitTypeSuccessAPI]);

  // Effect add renewal frequency success
  useEffect(() => {
    if (isEmpty(addRenewalFrequenciesSuccessAPI)) return;
    if (addRenewalFrequenciesSuccessAPI?.status === 200) {
      toast.success(addRenewalFrequenciesSuccessAPI?.message);
      dispatch(getRenewalFrequenciesList());
    } else {
      toast.error(addRenewalFrequenciesSuccessAPI?.message);
    }
    dispatch(addRenewalFrequenciesSuccess([]));
  }, [addRenewalFrequenciesSuccessAPI]);

  // Effect update renewal frequency success
  useEffect(() => {
    if (isEmpty(updateRenewalFrequenciesSuccessAPI)) return;
    if (updateRenewalFrequenciesSuccessAPI?.status === 200) {
      toast.success(updateRenewalFrequenciesSuccessAPI?.message);
      dispatch(getRenewalFrequenciesList());
    } else {
      toast.error(updateRenewalFrequenciesSuccessAPI?.message);
    }
    dispatch(updateRenewalFrequenciesSuccess([]));
  }, [updateRenewalFrequenciesSuccessAPI]);

  // Effect delete renewal frequency success
  useEffect(() => {
    if (isEmpty(deleteRenewalFrequenciesSuccessAPI)) return;
    if (deleteRenewalFrequenciesSuccessAPI?.status === 200) {
      toast.success(deleteRenewalFrequenciesSuccessAPI?.message);
      dispatch(getRenewalFrequenciesList());
      setDeleteModal(false);
    } else {
      toast.error(deleteRenewalFrequenciesSuccessAPI?.message);
    }
    dispatch(deleteRenewalFrequenciesSuccess([]));
  }, [deleteRenewalFrequenciesSuccessAPI]);

  // Effect add unit frequency success
  useEffect(() => {
    if (isEmpty(addUnitFrequenciesSuccessAPI)) return;
    if (addUnitFrequenciesSuccessAPI?.status === 200) {
      toast.success(addUnitFrequenciesSuccessAPI?.message);
      dispatch(getUnitFrequenciesList());
    } else {
      toast.error(addUnitFrequenciesSuccessAPI?.message);
    }
    dispatch(addUnitFrequenciesSuccess([]));
  }, [addUnitFrequenciesSuccessAPI]);

  // Effect update unit frequency success
  useEffect(() => {
    if (isEmpty(updateUnitFrequenciesSuccessAPI)) return;
    if (updateUnitFrequenciesSuccessAPI?.status === 200) {
      toast.success(updateUnitFrequenciesSuccessAPI?.message);
      dispatch(getUnitFrequenciesList());
    } else {
      toast.error(updateUnitFrequenciesSuccessAPI?.message);
    }
    dispatch(updateUnitFrequenciesSuccess([]));
  }, [updateUnitFrequenciesSuccessAPI]);

  // Effect delete unit frequency success
  useEffect(() => {
    if (isEmpty(deleteUnitFrequenciesSuccessAPI)) return;
    if (deleteUnitFrequenciesSuccessAPI?.status === 200) {
      toast.success(deleteUnitFrequenciesSuccessAPI?.message);
      dispatch(getUnitFrequenciesList());
      setDeleteModal(false);
    } else {
      toast.error(deleteUnitFrequenciesSuccessAPI?.message);
    }
    dispatch(deleteUnitFrequenciesSuccess([]));
  }, [deleteUnitFrequenciesSuccessAPI]);

  // Effect add master time frame success
  useEffect(() => {
    if (isEmpty(addMasterTimeFrameSuccessAPI)) return;
    if (addMasterTimeFrameSuccessAPI?.status === 200) {
      toast.success(addMasterTimeFrameSuccessAPI?.message);
      dispatch(getMasterTimeFrameList());
    } else {
      toast.error(addMasterTimeFrameSuccessAPI?.message);
    }
    dispatch(addMasterTimeFrameSuccess([]));
  }, [addMasterTimeFrameSuccessAPI]);

  // Effect update master time frame success
  useEffect(() => {
    if (isEmpty(updateMasterTimeFrameSuccessAPI)) return;
    if (updateMasterTimeFrameSuccessAPI?.status === 200) {
      toast.success(updateMasterTimeFrameSuccessAPI?.message);
      dispatch(getMasterTimeFrameList());
    } else {
      toast.error(updateMasterTimeFrameSuccessAPI?.message);
    }
    dispatch(updateMasterTimeFrameSuccess([]));
  }, [updateMasterTimeFrameSuccessAPI]);

  // Effect delete master time frame success
  useEffect(() => {
    if (isEmpty(deleteMasterTimeFrameSuccessAPI)) return;
    if (deleteMasterTimeFrameSuccessAPI?.status === 200) {
      toast.success(deleteMasterTimeFrameSuccessAPI?.message);
      dispatch(getMasterTimeFrameList());
      setDeleteModal(false);
    } else {
      toast.error(deleteMasterTimeFrameSuccessAPI?.message);
    }
    dispatch(deleteMasterTimeFrameSuccess([]));
  }, [deleteMasterTimeFrameSuccessAPI]);

  return (
    <>
      {deleteModal && (
        <DeleteModal
          show={deleteModal}
          onDeleteClick={handleDeleteStatus}
          onCloseClick={() => {
            setDeleteModal(false);
          }}
        />
      )}

      <SettingsPanel
        title="General"
        description="Your personal profile preferences."
      >
        {/* Task 24733 - per-staff opt-out for the bug-report button. Sits above
            the raw Local Settings table because it is the one setting here a
            non-technical user is likely to want. */}
        <div className="mb-3">
          <FeedbackToolToggle scope="user" />
        </div>

        {activeTab === "1" && <UserProfileLocalSettings />}
      </SettingsPanel>
    </>
  );
}
